import React, { memo } from "react";
import styled from "styled-components";

interface ICommercialsSummaryItem {
  commercialId: string;
  name: string;
  quantity?: number | 0;
  unitPrice?: number | 0;
  currency?: string;
  image?: string;
}

interface IStyle {
  grid: string;
}

const CommercialItemWrapper = styled.div<IStyle>`
  display: grid;
  grid-template-columns: ${(props) => props.grid};
  column-gap: 10px;
  font-size: 12px;
  line-height: 12px;
  align-items: center;
  padding: 5px 0;
`;

const Commercial = styled.div`
  display: flex;
  align-items: center;
`;

const CommercialTitle = styled.span`
  display: inline-block;
  max-width: 165px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  align-items: center;
`;

const CommercialQuantity = styled.span`
  white-space: nowrap;
`;

const CommercialPrice = styled.div`
  font-weight: bold;
  text-align: right;
  white-space: nowrap;
`;

const Item = (props: ICommercialsSummaryItem) => {
  const quantity = `${props.quantity} x `;
  const price = props.unitPrice ? (props.unitPrice / 100).toFixed(2) : 0;

  let grid;
  props.quantity! > 0 ? (grid = "30px auto") : (grid = "auto");
  price! > 0 ? (grid += " 60px") : (grid += "");

  return (
    <CommercialItemWrapper
      data-test={`commercial-item-wrapper-${props.commercialId}`}
      grid={grid}
    >
      {props.quantity! > 0 && (
        <CommercialQuantity>{quantity}</CommercialQuantity>
      )}
      <Commercial>
        {props.image && <img src={props.image} alt={props.name} />}
        <CommercialTitle>{props.name}</CommercialTitle>
      </Commercial>
      {price! > 0 && (
        <CommercialPrice>
          {price} {props.currency}
        </CommercialPrice>
      )}
    </CommercialItemWrapper>
  );
};

export const SummaryCommercialItem = memo(Item);
